import { createTheme } from 'components/base/system/theme';
import { themePalette } from './palettle';
import { TypographyVariant } from './typography';

export const baseTheme = createTheme({
  palette: themePalette,
  typography: TypographyVariant,
});
